/* eslint-disable react/prop-types */
import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { FaArrowRight, FaHome, FaLanguage, FaLockOpen } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useSelector, useDispatch } from "react-redux";
import { userLogout } from "../store/languageSlice";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";

const Navigation = (props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const { title, appBarColor } = props;
  const [openModal, setOpenModal] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.Language);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(!open);
  };
  function onOkHandler() {
    dispatch(userLogout());
    setOpenModal(false);
    navigate("/login");
    toggleDrawer();
  }

  const list = (anchor) => (
    <Box
      sx={{ width: "70vw" }}
      role="presentation"
      onClick={toggleDrawer(anchor)}
      onKeyDown={toggleDrawer(anchor)}
    >
      <div className="main-box">
        <div className="profile rounded-full bg-default items-center text-white font-light text-4xl h-[80px] w-[80px] flex  justify-center mt-8 mx-auto ">
          {/* { user !== 'Guest User' ? user : 'S' } */}S
        </div>
        <div className="text-center">
          <span className="text-center text-default text-lg text-bold">
            {user}
          </span>
        </div>
        <div className="link mt-40 px-2">
          <ul>
            <li
              className="flex gap-6 items-center my-5 border-b pb-4 border-dashed"
              onClick={() => {
                navigate("/");
                toggleDrawer();
              }}
            >
              <FaHome className="text-2xl text-gray-500" />
              <span className="text-primaryDark font-light text-base">
                {t("DASHBOARD")}
              </span>
            </li>

            <li
              className="flex gap-6 items-center my-5 border-b pb-4 border-dashed"
              onClick={() => {
                navigate("/language");
                toggleDrawer();
              }}
            >
              <FaLanguage className="text-2xl text-gray-500" />
              <span className="text-primaryDark font-light text-base">
                {t("LANGUAGES")}
              </span>
            </li>

            <li
              className="flex gap-6 items-center my-5 "
              onClick={() => {
                if (user !== "Guest User") {
                  setOpenModal(true);
                } else {
                  navigate("/login");
                  toggleDrawer();
                }
              }}
            >
              <FaLockOpen className="text-2xl text-gray-500" />
              <span className="text-primaryDark font-light text-base">
                {user !== "Guest User" ? t("LOGOUT") : t("LOGIN")}
              </span>
            </li>
          </ul>
        </div>

        <div className="bottomMenu absolute bottom-0 w-full my-4">
          <div className="flex justify-between mx-3">
            <p
              className="text-xs text-gray-400"
              onClick={() => navigate("/privacy_policy")}
            >
              {t("PRIVACY_POLICY")}
            </p>
            <p className="text-xs text-gray-400">{t("VERSION")}: 0.1</p>
          </div>
        </div>
      </div>
    </Box>
  );

  return (
    <>
      <Box sx={{ flexGrow: 1 , height:"74px" }}>
        <AppBar
          position="fixed"
          sx={{ backgroundColor: `${appBarColor}`  }}
          className="py-2"
        >
          <Toolbar>
            {pathname === "/home" ? (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={toggleDrawer(isDrawerOpen)}
              >
                <MenuIcon className="font-4xl" />
              </IconButton>
            ) : pathname === "/language"  ? (
              <></>
            ) : (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="back"
                sx={{ mr: 2 }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBackIcon className="font-4xl" />
              </IconButton>
            )}
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {t(title)}
            </Typography>
          </Toolbar>
        </AppBar>

        <SwipeableDrawer
          anchor={"left"}
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
          onOpen={() => {
            setIsDrawerOpen(true);
          }}
        >
          {list(isDrawerOpen)}
        </SwipeableDrawer>
      </Box>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="flex modal-justify-center flex-col items-center modal-content"
        >
          <FaArrowRight className="text-center text-[3.5rem] text-gray-300 my-3" />
          <p className="text-base mb-0 text-center text-gray-600 font-normal">
            {t("LOGOUT_CONFIRMATION")}
          </p>
        </DialogTitle>
        <DialogActions className="flex modal-justify-center">
          <button
            type="button"
            className="bg-slate-400 uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 shadow shadow-slate-400 "
            onClick={() => setOpenModal(false)}
            autoFocus
          >
            {t("CANCEL")}
          </button>
          <button
            type="button"
            className="bg-default  uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 shadow shadow-slate-400 "
            onClick={onOkHandler}
            autoFocus
          >
            {t("OK")}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Navigation;
